import { render, staticRenderFns } from "./ComplianceInformationStepV2.vue?vue&type=template&id=8a15f708&scoped=true&"
import script from "./ComplianceInformationStepV2.vue?vue&type=script&lang=js&"
export * from "./ComplianceInformationStepV2.vue?vue&type=script&lang=js&"
import style0 from "./ComplianceInformationStepV2.vue?vue&type=style&index=0&id=8a15f708&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a15f708",
  null
  
)

export default component.exports